export default __webpack_public_path__ + "static/media/crewforeman.06fdda38.png";